import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const noOp = () => {
	undefined;
};
if (environment.production) {
	enableProdMode();
	if (environment.production) {
		window.console.log = noOp;
		window.console.warn = noOp;
		window.console.info = noOp;
		window.console.error = noOp;
		window.console.debug = noOp;
	}
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((err) => console.error(err));
